export const DEFAULT_REGION = 'us-west-2';
export const DEFAULT_PARTITION = 'com';
const constructEndpoint = (subDomain) => ([awsRegion, awsPartition]) => ({
    url: new URL(`https://${subDomain}.${awsRegion}.amazonaws.${awsPartition}/`),
});
export const getEndpointPovider = ({ subDomain, awsRegion, awsPartition, }) => {
    let region = Promise.resolve(DEFAULT_REGION);
    let partition = Promise.resolve(DEFAULT_PARTITION);
    if (awsRegion) {
        region =
            typeof awsRegion === 'string' ? Promise.resolve(awsRegion) : awsRegion();
    }
    if (awsPartition) {
        partition =
            typeof awsPartition === 'string'
                ? Promise.resolve(awsPartition)
                : awsPartition();
    }
    return () => Promise.all([region, partition]).then(constructEndpoint(subDomain));
};
